import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import Userback from "@userback/widget";
import App from './App.district';
import APPSETTINGS from '@appsettings';
import { loadPunchlist } from './common/punchlist';
if (APPSETTINGS.USERBACK_KEY) {
    Userback(APPSETTINGS.USERBACK_KEY);
}
loadPunchlist();
createRoot(document.getElementById('root')).render(__DEV__ ? _jsx(StrictMode, { children: _jsx(App, {}) }) : _jsx(App, {}));
